import React, { createContext } from 'react';
import { type AssetView } from '../../types/assetView.types';

interface AssetProviderProps {
  assets: AssetView[];
  children: React.ReactNode;
}

const AssetContext = createContext<AssetView[] | null>(null);

const AssetProvider = ({ assets, children }: AssetProviderProps) => (
  <AssetContext.Provider value={assets}>{children}</AssetContext.Provider>
);

export { AssetContext, AssetProvider };
